import $ from 'jquery';
import CartJS from 'shopify-cartjs';

document.addEventListener('alpine:init', () => {

    const debounce = (func, wait) => {
        let timeout;
        return function executedFunction(...args) {
            const later = () => {
                clearTimeout(timeout);
                func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    };

    Alpine.store('cart', {
        items: [],
        cartObject: false,
        discountTotal: 0,
        discountName: '',
        subTotal: 0,
        compareTotal: 0,
        itemsCount: 0,
        isOpen: false,
        cartError: '',
        price(price) {
            if (!price) return;
    
            const newPrice = price / 100;
            const formattedPrice = newPrice.toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD'
            });
    
            return formattedPrice;
        },
        sortByPrice(items) {
            if (!items.length) return [];
            return items.sort((a, b) => a.price - b.price);
        },
        addToCart(variantId, quantity, sellingPlanId, compareAtPrice) {
            const activeQTY = quantity || 1;
        
            const props = {};
        
            if (compareAtPrice) {
                props._compare_at_price = compareAtPrice;
            }
        
            if (sellingPlanId) {
                props.selling_plan = sellingPlanId;
            }
        
            CartJS.addItem(
                variantId,
                activeQTY,
                props,
                {
                    success: (data) => {
                        this.isOpen = true;
                        console.log('SUCCESS', data);
                    },
                    error: (jqXHR) => {
                        this.cartError =
                            jqXHR?.responseJSON?.description ||
                            jqXHR?.responseJSON?.message ||
                            jqXHR?.responseText ||
                            "error";
        
                        console.log('ERROR', jqXHR);
                    }
                }
            );
        },
        updateCart(cart) {
            console.log(cart, 22222);
            if (!cart) {
                cart = CartJS.cart;
            }

            this.cartObject = CartJS.cart;
            this.items = cart.items;
            this.subTotal = cart.total_price;
            this.compareTotal = cart.original_total_price;
            this.itemsCount = cart.item_count;
            this.discountTotal = cart.total_discount;
            this.discountName = cart?.cart_level_discount_applications[0]?.title || '';

        },
        currency() {
            return this.getCurrencySymbol(CartJS.cart.currency);
        },

        decodeHtmlEntities(str) {
            const entities = {
                "&amp;": "&",
                "&lt;": "<",
                "&gt;": ">",
                "&quot;": "\"",
                "&#39;": "'"
            };
            if (!str) return '';
            return str.replace(/&amp;|&lt;|&gt;|&quot;|&#39;/g, match => entities[match]);
        },

        getProductName(title) {
            const titleParts = title ?  title.split('|') :  false;
            const formattedTitle = titleParts ? this.decodeHtmlEntities(titleParts[0]) + ' | ' + this.decodeHtmlEntities(titleParts[1]) : '';
            return formattedTitle;
        },

        getSubtotal() {
            const subtotal = `${this.currency()}${CartJS.cart.total_price / 100}`;
            return subtotal;
        },

        get cartTotalPrice() {
            const priceObj = {
                price: this.price(this.cartObject?.total_price),
                comparePrice: this.price(this.cartObject?.original_total_price),
            }
            return priceObj;
        },
    
        getCurrencySymbol(currency) {
            const symbols = {
                'USD': '$',
                'EUR': '€',
                'GBP': '£',
                'RUB': '₽',
                'JPY': '¥',
                'CNY': '¥',
            };
            return symbols[currency] || currency;
        },

        updateItem: debounce((itemId, quantity) => {
            CartJS.updateItemById(itemId, quantity, {}, {
                "success": (cart, textStatus, jqXHR) => {
                    Alpine.store('cart').updateCart(cart);
                },
                "error": (jqXHR, textStatus, errorThrown) => {
                    console.log('error');
                    Alpine.store('cart').cartError = jqXHR.responseJSON.description;
                }
            }); 
        }, 500),

        removeItem(itemId) {
            CartJS.removeItemById(itemId);
        },

        init() {
            CartJS.init(window.CartObject, {
                "dataAPI": false,
                "requestBodyClass": "loading"
            });

            if (CartJS.cart) {
                this.cartObject = CartJS.cart;
                this.items = CartJS.cart.items;
                this.itemsCount = CartJS.cart.item_count;
                this.subTotal = CartJS.cart.total_price;
                this.compareTotal = CartJS.cart.original_total_price;
                this.discountTotal = CartJS.cart.total_discount;
                this.discountName = CartJS.cart?.cart_level_discount_applications?.length > 0 ? CartJS.cart?.cart_level_discount_applications[0]?.title : '';
            }
        },
    });

    jQuery(document).on('cart.requestComplete', function(event, cart) {
        Alpine.store('cart').updateCart(cart);
    });
});
